/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module SecurityModule
 */

import { Injector } from '@angular/core';

import {
    AuthProfileCollection,
    AUTH_PROFILE_COLLECTION_TOKEN,
    CertificateManagementCollection,
    CERTIFICATE_MANAGEMENT_COLLECTION_TOKEN,
    JWTServerProfile,
    JWTServerProfileCollection,
    jwtServerProfileToken,
    TCertificateManagementCollection,
} from 'ajs/modules/security/factories';

import {
    GeoDb,
    GeoDbFileConfigItem,
    GeoDbMappingConfigItem,
    GeoDbMappingElementConfigItem,
    GEO_DB_FILE_CONFIG_ITEM_TOKEN,
    GEO_DB_ITEM_TOKEN,
    GEO_DB_MAPPING_CONFIG_ITEM_TOKEN,
    GEO_DB_MAPPING_ELEMENT_CONFIG_ITEM_TOKEN,
} from 'ajs/modules/geo-db/factories';

import {
    ControlScriptCollection,
    CONTROL_SCRIPT_COLLECTION_TOKEN,
    TControlScriptCollection,
} from 'ajs/modules/scripts';

import {
    JWT_SERVER_PROFILE_COLLECTION_TOKEN,
} from 'ajs/modules/security/security.tokens';

const $injector = '$injector';

export const jwtServerProfileCollectionProvider = {
    deps: [$injector],
    provide: JWTServerProfileCollection,
    useFactory(injector: Injector): typeof JWTServerProfileCollection {
        return injector.get(JWT_SERVER_PROFILE_COLLECTION_TOKEN);
    },
};

export const jwtServerProfileProvider = {
    deps: [$injector],
    provide: JWTServerProfile,
    useFactory(injector: Injector): typeof JWTServerProfile {
        return injector.get(jwtServerProfileToken);
    },
};

export const geoDbProvider = {
    deps: [$injector],
    provide: GeoDb,
    useFactory(injector: Injector): typeof GeoDb {
        return injector.get(GEO_DB_ITEM_TOKEN);
    },
};

export const geoDbFileConfigItemProvider = {
    deps: [$injector],
    provide: GeoDbFileConfigItem,
    useFactory(injector: Injector): typeof GeoDbFileConfigItem {
        return injector.get(GEO_DB_FILE_CONFIG_ITEM_TOKEN);
    },
};

export const geoDbMappingConfigItemProvider = {
    deps: [$injector],
    provide: GeoDbMappingConfigItem,
    useFactory(injector: Injector): typeof GeoDbMappingConfigItem {
        return injector.get(GEO_DB_MAPPING_CONFIG_ITEM_TOKEN);
    },
};

export const geoDbMappingElementConfigItemProvider = {
    deps: [$injector],
    provide: GeoDbMappingElementConfigItem,
    useFactory(injector: Injector): typeof GeoDbMappingElementConfigItem {
        return injector.get(GEO_DB_MAPPING_ELEMENT_CONFIG_ITEM_TOKEN);
    },
};

export const controlScriptCollectionProvider = {
    deps: [$injector],
    provide: ControlScriptCollection,
    useFactory(injector: Injector): TControlScriptCollection {
        return injector.get(CONTROL_SCRIPT_COLLECTION_TOKEN);
    },
};

export const certificateManagementCollectionProvider = {
    deps: [$injector],
    provide: CertificateManagementCollection,
    useFactory(injector: Injector): TCertificateManagementCollection {
        return injector.get(CERTIFICATE_MANAGEMENT_COLLECTION_TOKEN);
    },
};

export const hsmGroupCollectionProvider = {
    deps: [$injector],
    provide: 'HSMGroupCollection',
    useFactory(injector: Injector): any {
        return injector.get('HSMGroupCollection');
    },
};

export const authProfileCollectionProvider = {
    deps: [$injector],
    provide: AuthProfileCollection,
    useFactory(injector: Injector): typeof AuthProfileCollection {
        return injector.get(AUTH_PROFILE_COLLECTION_TOKEN);
    },
};
